function convertSettings(resData) {

    const model = {};

    model.general_setting = {
        site_logo: '',
    };

    for (let i = 0; i < resData.length; i++) {
        let data = resData[i];
        if (typeof model[data.code] === 'undefined') {
            model[data.code] = {};
        }
        if(data.origin_id == null) {
          model[data.code][data.setting_key] = data.setting;
        }
    }

    return model;
}

export default convertSettings


// WEBPACK FOOTER //
// ./src/libs/settings.js